(() => {
  document.documentElement.classList.add('ccc-motion-ready');

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const reveal = () => {
    const elements = document.querySelectorAll('.ccc-reveal:not(.ccc-is-visible)');
    if (reducedMotion || !('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('ccc-is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('ccc-is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    elements.forEach((element) => observer.observe(element));
  };

  document.addEventListener('DOMContentLoaded', reveal);
  document.addEventListener('shopify:section:load', reveal);
})();
